import { render, staticRenderFns } from "./AiLeadsPublicTableSurvey.vue?vue&type=template&id=2238dbec&scoped=true"
import script from "./AiLeadsPublicTableSurvey.vue?vue&type=script&lang=js"
export * from "./AiLeadsPublicTableSurvey.vue?vue&type=script&lang=js"
import style0 from "./AiLeadsPublicTableSurvey.vue?vue&type=style&index=0&id=2238dbec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2238dbec",
  null
  
)

export default component.exports